import React, { useEffect } from 'react';
import { Form, Input, InputNumber, message, Modal } from 'antd';
import {
  createKnowledgeBase,
  getKnowledgeBaseDetail,
  updateKnowledgeBase,
  KnowledgeBaseVo,
} from '@/api/knowledgeBase';

export interface EditKnowledgeBaseProp {
  data?: KnowledgeBaseVo;
  isEdit?: boolean;
  updateFn: () => void;
  onCancel: () => void;
}

const EditKnowledgeBase = ({ data, isEdit, updateFn, onCancel }: EditKnowledgeBaseProp) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    if (isEdit && data?.id) {
      setLoading(true);
      getKnowledgeBaseDetail(data.id)
        .then(res => form.setFieldsValue(res))
        .finally(() => setLoading(false));
    }
  }, [data?.id, isEdit, form]);

  const onFinish = () => {
    form.validateFields().then(values => {
      const params = { ...values, id: isEdit ? data?.id : undefined };
      const api = isEdit ? updateKnowledgeBase : createKnowledgeBase;
      api(params as any).then(() => {
        message.success('保存成功');
        onCancel();
        updateFn();
      });
    });
  };

  return (
    <Modal
      title={isEdit ? '编辑知识库' : '新增知识库'}
      open={true}
      onCancel={onCancel}
      onOk={onFinish}
      maskClosable={false}
      width={600}
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical" initialValues={{ chunkSize: 500, chunkOverlap: 50, retrievalTopK: 5, retrievalThreshold: 0.7 }}>
        <Form.Item name="name" label="知识库名称" rules={[{ required: true, message: '请输入知识库名称' }]}>
          <Input placeholder="请输入知识库名称" />
        </Form.Item>
        <Form.Item name="description" label="知识库描述">
          <Input.TextArea rows={2} placeholder="请输入知识库描述" />
        </Form.Item>
        <Form.Item name="chunkSize" label="分块大小" tooltip="文档分块的最大字符数，不同类型文档可能需要不同大小">
          <InputNumber min={100} max={2000} style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item name="chunkOverlap" label="分块重叠" tooltip="相邻分块的重叠字符数">
          <InputNumber min={0} max={200} style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item name="retrievalTopK" label="检索数量" tooltip="检索时返回的最大分块数">
          <InputNumber min={1} max={20} style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item name="retrievalThreshold" label="相关性阈值" tooltip="检索结果的最小相关性分数">
          <InputNumber min={0} max={1} step={0.1} precision={2} style={{ width: '100%' }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditKnowledgeBase;